<main class="wrapper min-vh-100">
  <lock-screen>
    <h3 class="text-center fw-light fs-4">{{this.user?.email}}</h3>
    <form-lock-screen></form-lock-screen>
  </lock-screen>
</main>